import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IHeaderState } from 'types/type.global';

const initialState: IHeaderState = {
    headerNotiBadgeInvisible: false,
};
const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        setHeaderNotiBadgeInvisible: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.headerNotiBadgeInvisible = action.payload;
        },
    },
});

export const { setHeaderNotiBadgeInvisible } = notificationSlice.actions;

export default notificationSlice.reducer;
